export default __webpack_public_path__ + "static/media/slide8.5ae910c7.jpg";